import list from './list/reducer';
import users from './users/reducer';
import single from './single/reducer';
import data from './data/reducer';
import assets from './assets/reducer';
import assetChanges from './assetChanges/reducer';

import { combineReducers } from 'redux';

export default combineReducers({
  list,
  single,
  users,
  assets,
  data,
  assetChanges,
});
